// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"63b59f65","667":"a745f336","977":"d408507a"}[chunkId] + ".chunk.js";
};